import { getCurrentInstance } from "vue";
import { d as dot } from "./index-fd2245c5.mjs";
const DefaultsSymbol = Symbol.for("vuetify:defaults");
const useDefaults = (defined, component) => {
  if ("object" !== typeof defined || null === defined || Array.isArray(defined)) {
    defined = {};
  }
  const vm = getCurrentInstance();
  if (vm) {
    const vuetifyDefinedDefaults = vm.appContext.provides[DefaultsSymbol];
    if (vuetifyDefinedDefaults.value[component]) {
      const defaulted = dot.dot(vuetifyDefinedDefaults.value[component]);
      const current = dot.dot(defined);
      const merged = {};
      Object.keys(defaulted).forEach((key) => {
        merged[key] = defaulted[key];
      });
      Object.keys(current).forEach((key) => {
        merged[key] = current[key];
      });
      defined = dot.object(merged);
    }
  }
  return defined;
};
const getDefault = (key, component, otherwise) => {
  const vm = getCurrentInstance();
  if (vm) {
    const vuetifyDefinedDefaults = vm.appContext.provides[DefaultsSymbol];
    if (vuetifyDefinedDefaults.value[component]) {
      const defaulted = dot.dot(vuetifyDefinedDefaults.value[component]);
      return defaulted[key];
    }
  }
  return otherwise;
};
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
export {
  _export_sfc as _,
  getDefault as g,
  useDefaults as u
};
//# sourceMappingURL=_plugin-vue_export-helper-3194dc60.mjs.map
